import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  hideFirstOption?: boolean;
  hidePaid?: boolean;
  hideReady?: boolean;
  status?: string;
  className?: string;
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const ServiceOrderHistoryStatusSelect: React.FC<IProps> = memo(
  ({
    hideFirstOption = false,
    hidePaid = false,
    hideReady = false,
    status,
    className,
    onChange,
  }) => {
    return (
      <Select
        className={className}
        style={{ width: 160 }}
        defaultValue="All"
        value={status}
        onChange={onChange}
      >
        {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        <Option value="Completed">{L('Service completed')}</Option>
        <Option hidden={hideReady} value="Ready">
          {L('Ready for payment')}
        </Option>
        <Option hidden={hidePaid} value="Paid">
          {L('Paid')}
        </Option>
      </Select>
    );
  }
);
